"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const formatValueToArray = value => {
  if (!value) return;
  return value?.split("-")?.map(item => parseInt(item));
};
var _default = exports.default = formatValueToArray;